'use client';

import type { ReactNode } from 'react';
import { z } from 'zod';
import { PythonRenderer } from '../../ToolCallsRenderers/renderers/PythonRenderer';
import { PlainTextRenderer } from '../../ToolCallsRenderers/renderers/PlainTextRenderer';
import type { OutputRenderContext } from '../../tool-config-types';

const PythonResultSchema = z
  .object({
    script: z.unknown().optional(),
    code: z.unknown().optional(),
    credentialId: z.unknown().optional(),
    output: z.unknown().optional(),
    result: z.unknown().optional(),
  })
  .catchall(z.unknown())
  .transform((value) => {
    const script =
      typeof value.script === 'string'
        ? value.script
        : typeof value.code === 'string'
          ? value.code
          : undefined;
    const credentialId =
      typeof value.credentialId === 'string' ? value.credentialId : undefined;
    return {
      ...value,
      script,
      credentialId,
    };
  });

export const renderPythonResult = (ctx: OutputRenderContext): ReactNode => {
  const { content, maxHeight } = ctx;

  if (typeof content === 'object' && content !== null) {
    const result = PythonResultSchema.safeParse(content);
    const normalizedData = result.success ? result.data : content;

    return (
      <PythonRenderer
        data={normalizedData as Record<string, unknown>}
        maxHeight={maxHeight}
      />
    );
  }

  if (typeof content === 'string') {
    return <PythonRenderer data={{ output: content }} maxHeight={maxHeight} />;
  }

  return <PlainTextRenderer content={String(content)} maxHeight={maxHeight} />;
};
